import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { withCurrentSearch } from "@/utils/searchParams";
import { confirmHorizonScanningToken } from "./api";
import { setHorizonScanningSession } from "./sessionKeys";

export function ConfirmScreen() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError("Missing confirm token.");
      return;
    }
    let cancelled = false;
    confirmHorizonScanningToken(token)
      .then((res) => {
        if (cancelled) return;
        setHorizonScanningSession("session", res.sessionToken);
        navigate(`/horizonscanning/watchlist?session=${encodeURIComponent(res.sessionToken)}`, { replace: true });
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err.message : "Could not confirm this address.");
      });
    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  if (error) {
    return (
      <div className="mx-auto max-w-xl px-5 py-16">
        <h1 className="text-2xl font-bold text-ink">We could not confirm that link</h1>
        <p className="mt-3 text-ink-soft">{error}</p>
        <Link className="mt-6 inline-block font-semibold text-brand-700" to={withCurrentSearch("/horizonscanning/start")}>
          Start again
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-xl px-5 py-16">
      <h1 className="text-2xl font-bold text-ink">Confirming your watchlist…</h1>
      <p className="mt-3 text-ink-soft">Creating the organisation.</p>
    </div>
  );
}
